import { gql } from 'graphql.macro'

export default gql`
  fragment KeyFragment on Key {
    id
    key
    secret
  }
`
